import React from 'react';
import WebFont from 'webfontloader';
import LandingPage from './components/pages/LandingPage.jsx';
import SurveyPage from './components/pages/SurveyPage.jsx';
import SummaryPage from './components/pages/SummaryPage.jsx';
import DetailsPage from './components/pages/DetailsPage.jsx';
import Header from './components/Header.jsx';
import Footer from "./components/Footer";
import { GuideAppContainer, NeuroMessage, PageContainer, PageNavigation, RenderOnlyFor } from "@ignitesales/neuro-application";

WebFont.load({
  google: {
    families: ['Oswald:400,700', 'Open Sans:300,400,400i,700,700i', 'Mulish: 300,400,600', 'Archivo Narrow: 400,700']
  }
});

const App = () => {

  const nextBtn = (<>
    <NeuroMessage id='nav.next' /><span className="fa fa-caret-right" />
  </>);
  const prevBtn = (<>
    <span className="fa fa-caret-left" /><NeuroMessage id='nav.prev' />
  </>);

  return (
    <GuideAppContainer>
      <RenderOnlyFor forLandingPage={true} forSurveyPage={true}>
        <Header />
      </RenderOnlyFor>
      <PageContainer
        LandingPage={LandingPage}
        SurveyPage={SurveyPage}
        SummaryPage={SummaryPage}
        DetailsPage={DetailsPage}
      />
      <RenderOnlyFor forSurveyPage={true}>
        <PageNavigation
          className='survey'
          innerNextBtn={nextBtn}
          innerPrevBtn={prevBtn}
        />
      </RenderOnlyFor>
      <RenderOnlyFor forSurveyPage forLandingPage>
        <Footer />
      </RenderOnlyFor>
    </GuideAppContainer>
  );
};

export default App;
